<template>
	<section id="share">
		<section class="top-adver" v-if="country!='in'">
			<img src="@/assets/invite/logo@2x.png" v-if="appId == 'com.mobz.vd.in.debug' || appId == 'com.mobz.vd.in'" class="share-top-logo" alt="">
			<img src="@/assets/invite/logo-wall@2x.png" v-if="appId == 'com.supertools.wallpaper'" class="share-top-logo" alt="">
			<div class="top-adver-title" :class="{'small':country == 'ph'}">
				{{document.sharePage[country].top_adver_title}}
			</div>
			<div class="top-adver-special-money">
				<div class="special-money-num">
					{{document.sharePage[country].special_money_num}}
				</div>
				<div class="special-money-name">
					{{document.sharePage[country].special_money_name}}
				</div>
			</div>
		</section>
		<section class="top-adver" v-if="country=='in'">
			<img src="@/assets/invite/logo@2x.png" v-if="appId == 'com.mobz.vd.in.debug' || appId == 'com.mobz.vd.in'" class="share-top-logo" alt="">
			<img src="@/assets/invite/logo-wall@2x.png" v-if="appId == 'com.supertools.wallpaper'" class="share-top-logo" alt="">
			<div class="top-adver-title">
				{{document.sharePage[country].top_adver_title}}
			</div>
			<div class="top-adver-special-money">
				<div class="special-money-name">
					{{document.sharePage[country].special_money_name}}
				</div>
				<div class="special-money-num money-start">
					{{document.sharePage[country].special_money_num}}
				</div>
			</div>
		</section>

		<section class="section-item invite-id-row">
			<div class="section-item-title">
				{{document.sharePage[country].id_item_title}}
			</div>
			<div class="coy-row" v-if="appData">
				<div class="invite-id-txt">
					{{appData.invitationCode}}
				</div>
				<div class="coy-btn" v-clipboard:copy="invitationCode" v-clipboard:success="onCopy" v-clipboard:error="onError">
					{{document.sharePage[country].copy}}
				</div>
			</div>
		</section>

		<section class="section-item invite-item-row">
			<div class="section-item-title">
				{{document.sharePage[country].invite_item_title}}
			</div>
			<div class="invite-step-row">
				<div class="step-item">
					<img src="@/assets/invite/step1@2x.png" class="step-img" alt="">
					<div class="step-num">
						{{document.sharePage[country].step}} 1
					</div>
					<div class="step-name">
						{{document.sharePage[country].step1}}
					</div>
				</div>
				<div class="next">
					<img src="@/assets/invite/next.png" class="step-next" alt="">
				</div>
				<div class="step-item">
					<img src="@/assets/invite/step2@2x.png" class="step-img" alt="">
					<div class="step-num">
						{{document.sharePage[country].step}} 2
					</div>
					<div class="step-name">
						{{document.sharePage[country].step2}}

					</div>
				</div>
				<div class="next">
					<img src="@/assets/invite/next.png" class="step-next" alt="">
				</div>
				<div class="step-item">
					<img src="@/assets/invite/step3@2x.png" class="step-img" alt="">
					<div class="step-num">
						{{document.sharePage[country].step}} 3
					</div>
					<div class="step-name">
						{{document.sharePage[country].step3}}

					</div>
				</div>

			</div>
		</section>

		<div class="auto-download-container" v-show="showAuto">
			<div class="auto-download-row">
				<div class="auto-download-msg">
					{{document.sharePage[country].auto_msg}}
				</div>
				<div class="auto-download-btn-row">
					<div class="auto-download-btn-item" @click="autoClick(0)">
						CANCEL
					</div>
					<div class="auto-download-btn-item activity" @click="autoClick(1)">
						CONTINUE
					</div>
				</div>
			</div>
		</div>

		<div class="share-large-btn" @click="download()">
			<div class="large-btn-txt">
				{{document.sharePage[country].download_btn}}
			</div>
		</div>

	</section>
</template>

<script>
// import "@/css/main.scss";
import "@/css/invite/share.scss";
import document from "@/utlis/document.js";

export default {
	name: "share",
	data() {
		return {
			pageName: "invite_share",
			appData: "",
			invitationCode: "0",
			autoDownload: true,
			apk: "",
			document: document,
			country: "id",
			showAuto: false,
			timer: null,
			appId: "com.mobz.vd.in.debug",
			appIdMap: {
				1: "com.mobz.vd.in.debug",
				2: "com.mobz.vd.in",
				3: "com.supertools.wallpaper",
				4: "com.supertools.newsbees",
			},
		};
	},
	created() {
		this.appData = window.data;
		if (this.$global.GetQueryString("country")) {
			this.country = this.$global.GetQueryString("country").toLowerCase();
		}
		if (this.$global.GetQueryString("a")) {
			this.appId = this.appIdMap[this.$global.GetQueryString("a")];
		}
		if (this.appId == "com.supertools.wallpaper") {
			this.country = "wallive";
		}
		if (this.appData) {
			this.autoDownload = this.appData.autoStatus;
			this.invitationCode = this.appData.invitationCode;
		}
	},
	mounted() {
		let _this = this;
		console.log(process.env);
		this.apk = this.appData.apk
			? this.appData.apk
			: "https://www.vidfree.net/app/android/apk/vidmate-sm.apk";
		if (this.autoDownload) {
			setTimeout(() => {
				_this.showAuto = true;

				_this.timer = setTimeout(() => {
					_this.downloadFunc();
					_this.showAuto = false;
					_this.$reportInstance.report({
						time: new Date(),
						message: "invited_auto_popup",
						method: "click",
						channel: _this.appId,
					});
				}, 3000);
				_this.$reportInstance.report({
					time: new Date(),
					message: "invited_auto_popup",
					method: "expose",
					channel: _this.appId,
				});
			}, 500);
		}

		this.$reportInstance.report({
			time: new Date(),
			message: "in_page_invited",
			method: "browse",
			channel: this.appId,
		});
	},
	beforeDestroy() {
		clearTimeout(this.timer);
	},
	methods: {
		download() {
			this.downloadFunc();
			this.$reportInstance.report({
				time: new Date(),
				message: "invited_download",
				method: "click",
				channel: this.appId,
			});
		},
		downloadFunc() {
			// if (this.appId == "com.supertools.wallpaper") {
			// 	window.location.href =
			// 		"https://wallive.onelink.me/QaY4/totalyoutube";
			// } else {
			// }
			this.$global.download(this.apk);
		},
		onCopy(e) {
			var extendts = {
				text: e.text,
			};
			this.$reportInstance.report({
				time: new Date(),
				message: "leave_page_invited",
				method: "browse",
				channel: this.appId,
				extensions: JSON.stringify(extendts),
			});
			// alert("You just copied: " + e.text);
		},
		autoClick(status) {
			if (status == 0) {
				clearTimeout(this.timer);
			}
			this.showAuto = false;
			this.$reportInstance.report({
				time: new Date(),
				message: status
					? "continue_invited_auto_popup"
					: "cancel_invited_auto_popup",
				method: "click",
				channel: this.appId,
			});
		},
		onError(e) {
			console.log(e);
			// alert("Failed to copy texts" + e);
		},
	},
};
</script>
